import { post } from "./labit-connection";

export let getDefaultColors = async () => {
  let response = await post(
    `select color
            from labitColors`
  );

  const labitColors = response.map((item) => {
    return item.color;
  });

  response = await post(
    `select distinct color
            from program_types`
  );

  const programColors = response.map((item) => {
    return item.color;
  });

  const colors = labitColors.concat(programColors);

  return colors;
};
